export default "__VITE_PUBLIC_ASSET__fa2bb850__"